// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"2a7ffae6","215":"4c78109e","831":"e5f5bc19","950":"78d10dcc","960":"b712cbfc"}[chunkId] + ".chunk.js";
};